import i18n from '@dms/i18n';

import {VEHICLE_FORM_EVENTS} from '../../core/machine/constants/VEHICLE_FORM_EVENTS';
import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

/**
 * Numeric input component for defining the time interval (in months) after which a vehicle service inspection should be performed.
 * Used in service interval tracking to set the service inspection frequency based on time.
 * Automatically calculates the next service inspection date when changed.
 */
export function ServiceInspectionAfterMonthsInput() {
  const {sendMachineEvent} = useVehicleFormContext();

  const handleChange = (value: number | null) => {
    sendMachineEvent({
      type: VEHICLE_FORM_EVENTS.SERVICE_INSPECTIONS_DATE_INTERVAL_CHANGED,
      value,
    });
  };

  return (
    <Field
      type="number"
      name="serviceIntervals.serviceInspection.replacementAfterMonths"
      label={i18n.t('entity.vehicle.labels.replacementAfterMonths')}
      suffix={i18n.t('general.metric.months')}
      onChange={handleChange}
    />
  );
}
